import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import credentialSlice from "./slices/credential-slice";
import menuSlice from "./slices/menu-slice";
import widgetSlice from "./slices/widget-slice";
import cartSlice from "./slices/cart-slice";

const persistConfig = {
  key: "BustanAlSukkar",
  version: 1.1,
  storage,
}

export const rootReducer = combineReducers({
  credential: credentialSlice,
  menu: menuSlice,
  widget: widgetSlice,
  cart: cartSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
